<template>
  <div
    class="modal fade"
    id="viewSimpleScheduledEvent"
    tabindex="-1"
    aria-labelledby="viewSimpleScheduledEventLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title text-center"
            id="viewSimpleScheduledEventLabel"
          >
            View Event Details
          </h5>

          <button
            type="button"
            class="btn-close"
            id="viewSimpleScheduledEventClose"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <h5 class="mb-3">Date: {{ getEventDate }}</h5>
          <label
            class="form-label mt-3"
            for="form6Example1"
            style="margin-top: 5px"
            >Name<span class="text-danger">*</span></label
          >
          <input
            type="text"
            id="form6Example1"
            class="form-control v-step-2"
            placeholder="e.g. Junior High Basketball Tournament"
            v-model="localSimpleScheduledEvent.name"
            required
          />

          <label
            class="form-label mt-3"
            for="form6Example4"
            style="margin-top: 5px"
            >Location (Optional)
            <span
              v-if="addressVerified"
              class="text-muted"
              style="font-size: 12px"
              ><i class="fa-solid fa-circle-check"></i> Verified</span
            >
          </label>
          <input
            type="text"
            id="form6Example4"
            class="form-control v-step-4"
            placeholder="e.g. 12:00 PM"
            v-model="localSimpleScheduledEvent.location"
            required
          />

          <div class="row mt-3">
            <div class="col-md-7 col-sm-3">
              <label class="form-label"
                >Description<span class="text-danger">*</span></label
              >
            </div>
          </div>

          <textarea
            class="form-control v-step-4"
            rows="4"
            placeholder="e.g. The Junior High Basketball Tournament will...."
            v-model="localSimpleScheduledEvent.description"
            required
            style="min-height: 150px"
          ></textarea>

          <div class="mt-3">
            <label class="form-label">Memberships (Optional)</label>
            <multiselect
              v-model="selectedMemberships"
              :options="memberships"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Select memberships"
              label="membershipName"
              track-by="_id"
              :preselect-first="false"
            >
              <template #selection="{ values, isOpen }">
                <span
                  class="multiselect__single"
                  v-if="values.length && !isOpen"
                >
                  {{ values.length }} memberships selected
                </span>
              </template>
            </multiselect>
          </div>

          <div class="row mt-3">
            <div class="col" style="margin-top: 5px">
              <label class="form-label" for="form6Example3">Start Time</label>
              <input
                v-model="localSchedule.startTime"
                required
                id="form6Example1"
                class="form-control mb-3"
                type="time"
              />
            </div>
            <div class="col" style="margin-top: 5px">
              <label class="form-label" for="form6Example3">End Time</label>
              <input
                v-model="localSchedule.endTime"
                required
                id="form6Example1"
                class="form-control mb-3"
                type="time"
              />
            </div>
          </div>

          <div class="form-check d-flex mb-4" style="margin-top: 20px">
            <input
              class="form-check-input me-2"
              type="checkbox"
              value=""
              v-model="localSchedule.repeating"
            />
            <label class="form-check-label v-step-8"> Is Recurring</label>
          </div>
          <div v-if="localSchedule.repeating">
            <ul class="list-group">
              <li class="list-group-item">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value="DAY"
                  v-model="localSchedule.repeatingSetting"
                />
                Every Day
              </li>
              <li class="list-group-item">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value="WEEK"
                  checked
                  v-model="localSchedule.repeatingSetting"
                />
                Every Week
              </li>
              <li class="list-group-item">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value="MONTH"
                  checked
                  v-model="localSchedule.repeatingSetting"
                />
                Every Month
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteSimpleScheduledEvent()"
          >
            Delete Event
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="updateSimpleScheduledEvent()"
          >
            Update Event
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import swal2 from 'sweetalert2'
import axios from 'axios'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      dayApplicable: 'TODAY',
      addressVerified: true,
      memberships: [],
      selectedMemberships: [],
      localSimpleScheduledEvent: { ...this.simpleScheduledEvent },
      localSchedule: { ...this.schedule },
    }
  },
  props: {
    simpleScheduledEvent: Object,
    schedule: Object,
    userID: String,
  },
  watch: {
    simpleScheduledEvent: {
      handler(newVal) {
        this.localSimpleScheduledEvent = { ...newVal }
      },
      deep: true,
    },
    schedule: {
      handler(newVal) {
        this.localSchedule = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    getAddressData(addressData, placeResultData, id) {
      console.log(placeResultData)
      console.log(id)
      console.log(addressData)
      this.localSimpleScheduledEvent.location =
        placeResultData.formatted_address
      this.addressVerified = true
    },
    setAddressData(e) {
      if (!this.localSimpleScheduledEvent.location || this.editMode) {
        console.log(e)
        this.localSimpleScheduledEvent.location = e.toString()
      }
    },
    async deleteSimpleScheduledEvent() {
      let inputOptions = new Promise(resolve => {
        setTimeout(() => {
          resolve({
            TODAY: 'Today',
            TODAYANDFOLLOWING: 'Today and Following',
            EVERYDAY: 'Every Day',
          })
        }, 500)
      })

      if (!this.localSchedule.repeating) {
        inputOptions = new Promise(resolve => {
          setTimeout(() => {
            resolve({
              TODAY: 'Today',
            })
          }, 500)
        })
      }

      const { value: period } = await swal2.fire({
        title: 'On which days would you like to delete this event?',
        showCancelButton: true,
        input: 'radio',
        inputOptions,
        inputValidator: value => {
          if (!value) {
            return 'Please select an option'
          }
        },
      })
      if (period) {
        swal('Loading...', '', 'info')
        let url =
          import.meta.env.VITE_APP_DB_URL +
          'scheduling/deleteSimpleScheduledEvent'
        axios
          .post(
            url,
            {
              eventID: this.localSimpleScheduledEvent._id,
              periodToDelete: period,
              dateSelected: this.localSchedule.date,
            },
            {
              headers: {
                Authorization: 'Bearer ' + localStorage.getItem('jwt'),
              },
            }
          )
          .then(response => {
            this.$emit('deletedSimpleScheduledEvent', {
              allAvailability: response.data.availability,
            })
            document.getElementById('viewSimpleScheduledEventClose').click()
            swal('Success', 'Calendar has been updated', 'success')
          })
          .catch(function (err) {
            let error = err.response
            swal('Error', error.data.errorMessage, 'error')
          })
      }
    },
    async fetchMemberships() {
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        const response = await axios.get(
          import.meta.env.VITE_APP_DB_URL +
            'membership/getCoachMemberships?id=' +
            user._id,
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('jwt'),
            },
          }
        )
        this.memberships = response.data
        // Set initial selected memberships based on the event's membershipIds
        if (
          this.localSimpleScheduledEvent &&
          this.localSimpleScheduledEvent.membershipIds
        ) {
          this.selectedMemberships = this.memberships.filter(
            membership =>
              membership &&
              membership._id &&
              this.localSimpleScheduledEvent.membershipIds.includes(
                membership._id
              )
          )
        }
      } catch (error) {
        console.error('Error fetching memberships:', error)
      }
    },
    async updateSimpleScheduledEvent() {
      if (
        !this.localSimpleScheduledEvent.name ||
        !this.localSimpleScheduledEvent.description ||
        !this.localSchedule.startTime ||
        !this.localSchedule.endTime
      ) {
        swal(
          'Details Incomplete',
          'Please fill out all form fields and try again',
          'error'
        )
        return
      }

      let inputOptions = new Promise(resolve => {
        setTimeout(() => {
          resolve({
            TODAY: 'Today',
            TODAYANDFOLLOWING: 'Today and Following',
            EVERYDAY: 'Every Day',
          })
        }, 500)
      })

      if (!this.localSchedule.repeating) {
        inputOptions = new Promise(resolve => {
          setTimeout(() => {
            resolve({
              TODAY: 'Today',
            })
          }, 500)
        })
      }
      const { value: period } = await swal2.fire({
        title: 'On which days would you like to update this event?',
        showCancelButton: true,
        input: 'radio',
        inputOptions,
        inputValidator: value => {
          if (!value) {
            return 'Please select an option'
          }
        },
      })
      if (period) {
        swal('Loading...', '', 'info')
        let url =
          import.meta.env.VITE_APP_DB_URL +
          'scheduling/updateSimpleScheduledEvent'

        // Update membershipIds with the selected memberships' IDs
        this.localSimpleScheduledEvent.membershipIds =
          this.selectedMemberships.map(membership => membership._id)

        axios
          .post(
            url,
            {
              simpleScheduledEvent: this.localSimpleScheduledEvent,
              schedule: this.localSchedule,
              periodToUpdate: period,
            },
            {
              headers: {
                Authorization: 'Bearer ' + localStorage.getItem('jwt'),
              },
            }
          )
          .then(response => {
            this.$emit('updatedSimpleScheduledEvent', {
              allAvailability: response.data.availability,
            })
            document.getElementById('viewSimpleScheduledEventClose').click()
            swal('Success', 'Calendar has been updated', 'success')
          })
          .catch(function (err) {
            let error = err.response
            swal('Error', error.data.errorMessage, 'error')
          })
      }
    },
  },
  computed: {
    getEventDate() {
      return this.localSchedule.date
    },
  },
  created() {
    this.fetchMemberships()
  },

  mounted() {},
}
</script>

<style scoped></style>

